'use strict';

import * as Colors from './Colors.js';
import {Logger} from './Logger.js';
import * as store from 'store2';
import {is_defined} from '../Helpers/js';

export class DebuggableObject {

    constructor(name, style) {
        this.name = name || this.constructor.name;
        this.logger = new Logger(style || Colors.grey, this.name);
        this.storage = store.namespace(this.name);
        this.storage.get('debug') == true ? this.logger.unmute() : this.logger.mute();
    }

    debug(value) {
        if (!is_defined(value)) {
            value = !this.storage.get('debug');
        }

        if (value) {
            this.storage.set('debug', true);
            this.logger.unmute();
            this.log('debug enabled');
        } else {
            this.log('debug disabled');
            this.logger.mute();
            this.storage.set('debug', false);
        }
    }

    debugging() {
        return this.storage.get('debug') ? true : false;
    }

    log(...messages) {
        this.logger.log(...messages);
    }

    static debug() {
        //@TODO: implement global switch | SEM-687
    }
}